import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PhoneInput from "@Shared/components/inputs/phone-input";
import MaterialInput from "@Shared/components/inputs/material-input";
import DatepickerInput from "@Shared/components/inputs/datepicker-input.vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { validDate, pastDate } from "@Shared/@Utils/validation-rules";
import AccountValidationMixin from "@Broker/js/mixins/validations/store-validations/account-mixin";
import ReferrersSelect from "@Broker/@Modules/clients/referrers/components/referrers-select.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ProfileDetailsForm",
  components: {
    PhoneInput,
    DatepickerInput,
    MaterialInput,
    ReferrersSelect
  },
  mixins: [validationMixin, AccountValidationMixin],
  data() {
    return {
      profileDetails: {
        givenName: "",
        familyName: "",
        email: "",
        phoneNumber: "",
        dateOfBirth: null,
        value: 0
      },
      referrerSelected: null,
      mask: {
        alias: "currency",
        rightAlign: false,
        prefix: "$",
        showMaskOnHover: false,
        allowMinus: false,
        allowPlus: false,
        autoUnmask: true,
        repeat: 10
      },
      profileDetailsEmailMaterialInput: ""
    };
  },
  validations: {
    profileDetails: {
      givenName: {
        required
      },
      email: {
        email,
        notCurrentAccountEmail(value) {
          return this.validation_notCurrentAccountEmail(value);
        },
        notConnectedAccountEmail(value) {
          return this.validation_notConnectedAccountEmail(value);
        }
      },
      dateOfBirth: {
        validDate,
        pastDate
      }
    }
  },
  computed: {
    isPending() {
      return this.$v.$pending;
    }
  },
  watch: {
    isPending(newVal, oldVal) {
      if (!this.$v.$invalid) setTimeout(() => {
        this.$refs.profileDetailsEmailMaterialInput.blur();
      }, 1000);
      if (!newVal && oldVal) this.updateProfileDetails();
    }
  },
  methods: {
    changeReferrer(referrer, type) {
      switch (type) {
        case "unselect":
          this.referrerSelected = null;
          break;
        case "select":
          this.referrerSelected = referrer.id;
          break;
      }
      this.updateProfileDetails();
    },
    updateProfileDetails() {
      const isValid = !this.$v.$invalid;
      this.$emit("change", _objectSpread({
        referrerId: this.referrerSelected || null
      }, this.profileDetails), isValid);
    }
  }
});